import { Amplify } from 'aws-amplify';

/**
 * Configure AWS Amplify for Cognito authentication
 */
export function configureAuth() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
        userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
        loginWith: {
          email: true,
        },
      },
    },
  });
}
